export default __webpack_public_path__ + "static/media/customer.cea5fc7d.svg";